export const district = (district) => {
    let d = "";
    switch (district) {
        case "Center": 
            d = "ԿԵՆՏՐՈՆ"
            break;
        case "Arabkir": 
            d = "ԱՐԱԲԿԻՐ"
            break;
        case "Davtashen": 
            d = "ԴԱՎԹԱՇԵՆ"
            break;
        case "Ajapnyak": 
            d = "ԱՋԱՓՆՅԱԿ"
            break;
        case "Vahagni-district": 
            d = "ՎԱՀԱԳՆԻ ԹԱՂԱՄԱՍ"
            break;
        case "Kanaker-Zeytun": 
            d = "ՔԱՆԱՔԵՌ-ԶԵՅԹՈՒՆ"
            break;
        case "Avan": 
            d = "ԱՎԱՆ"
            break;
        case "Nor-Norq": 
            d = "ՆՈՐ ՆՈՐՔ"
            break;
        case "Nork-Marash": 
            d = "ՆՈՐՔ-ՄԱՐԱՇ"
            break;
        case "Shengavit": 
            d = "ՇԵՆԳԱՎԻԹ"
            break;
        case "Malatia-Sebastia": 
            d = "ՄԱԼԱԹԻԱ-ՍԵԲԱՍՏԻԱ"
            break;
        case "Erebuni": 
            d = "ԷՐԵԲՈՒՆԻ"
            break;
        case "Jrvej":
            d = "ՋՐՎԵԺ"
            break;
        case "Zovuni":
            d = "ԶՈՎՈՒՆԻ"
            break;
        case "Dzoraghpyur":
            d = "ՁՈՐԱՂԲՅՈՒՐ"
            break;
        case "Ptghni":
            d = "ՊՏՂՆԻ"
            break;
	case "Arzni":
            d = "ԱՐԶՆԻ"
            break;
        case "Qasakh":
            d = "ՔԱՍԱԽ"
            break;
        case "Nor-Geghi":
            d = "ՆՈՐ ԳԵՂԻ"
            break;
        case "Nor-Hajn":
            d = "ՆՈՐ ՀԱՃՆ"
            break;
        case "Tsakhkadzor":
            d = "ԾԱՂԿԱՁՈՐ"
            break;
        case "Abovyan":
            d = "ԱԲՈՎՅԱՆ"
            break;
        case "Proshyan":
            d = "ՊՌՈՇՅԱՆ"
            break;
        case "Arinj":
            d = "ԱՌԻՆՋ"
            break;
	case "Byureghavan":
            d = "ԲՅՈՒՐԵՂԱՎԱՆ"
            break;
	case "Yeghvard":
            d = "ԵՂՎԱՐԴ"
            break;
        case "Dilijan":
            d = "ԴԻԼԻՋԱՆ"
            break;
        default:
            d = "";
            break;
    }
    return d;
}

export const buildingStatus = (bs) => {
  let b = "";
  switch (bs) {
    case "Renovated":
      b = "ՎԵՐԱՆՈՐՈԳՎԱԾ";
      break;
    case "Good-Condition":
      b = "ԼԱՎ ԿԱՐԳԱՎԻՃԱԿՈՒՄ";
      break;
    default:
      b = "ԶՐՈՅԱԿԱՆ";
      break;
  }
  return b;
};
export const buildingtype = (bt) => {
  let b = "";
  switch (bt) {
    case "Panel":
      b = "ՊԱՆԵԼԱՅԻՆ";
      break;
    case "Stone":
      b = "ՔԱՐԵ";
          break;
      case "Monolith":
      b = "ՄՈՆՈԼԻՏ";
      break;
    default:
      b = "";
      break;
  }
  return b;
};
